export const goodsCategoryTreeProps = {
  label: 'kindName',
  children: 'children',
}
